import React, { useState, useRef } from 'react'
import { Input, Select, Popconfirm, Tooltip, Button, Modal, InputNumber, message } from 'antd'
import { MenuOutlined, DeleteOutlined } from '@ant-design/icons'
import { Draggable } from 'react-beautiful-dnd'

export default (props) => {
    const {
        conditions,
        condition,
        index,
        partners,
        isFit,
        activeKey,
        isMultiFrames,
        onChangeRecord,
        removeRecord,
        onAddSizeFrames,
        sizeFrames,
    } = props
    const [searchValue, setSearchValue] = useState("")

    const timeoutRef = useRef(null)

    const { is_enable = false, min, max, min_per_batch, max_per_batch, partner = '', frame = {}, user_prefix = '' } = { ...condition }
    const [validate] = useState({})
    const listFrames = conditions.map(c => !!c.frame && !!c.frame.label && c.frame.label).filter(Boolean) || []

    const handleSearchRecord = (value) => {
        setSearchValue(value)

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            const isValidFormat = /^\d+x\d+$/.test(value)
            if (!isValidFormat) return

            if (!sizeFrames.some(opt => opt.label === value)) {
                const [w, h] = value.split("x")
                const newValue = { label: `${w}x${h}`, w, h }
                onAddSizeFrames(newValue)
            }
        }, 500)
    }

    const handleKeyDownRecord = (e, activeKey, filed, index) => {
        if (e.key === "Enter") {
            onChangeRecord(activeKey, filed, searchValue, index)
        }
    }

    return (
        <Draggable key={`condition-${index}`} draggableId={String(`condition-${index}`)} index={index}>
            {(provided, snapshot) => (
                <tr
                    className={['Condition', !is_enable && 'Inactive'].filter(Boolean).join(' ')}
                    key={`condition-${index}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{
                        ...provided.draggableProps.style
                    }}
                >
                    <td className="ConditionIndex">
                        <MenuOutlined style={{ cursor: 'grab' }} {...provided.dragHandleProps} />
                    </td>
                    <td className="Quantity">
                        {
                            !isMultiFrames ?
                                <Input
                                    className="QtyFrom"
                                    type="number"
                                    min={0}
                                    placeholder={isFit ? "Tỉ lệ" : "Số lượng >"}
                                    value={min}
                                    suffix={false}
                                    onChange={e => onChangeRecord(activeKey, 'min', e.target.value, index)}
                                    style={{ width: '150px' }}
                                /> :
                                <Select
                                    placeholder="Chọn lưới"
                                    value={frame.label ? frame.label : []}
                                    allowClear
                                    onChange={value => onChangeRecord(activeKey, 'frame', value, index)}
                                    onSearch={handleSearchRecord}
                                    onInputKeyDown={e => handleKeyDownRecord(e, activeKey, 'frame', index)}
                                    style={{ width: '150px' }}
                                    showSearch
                                >
                                    {sizeFrames.map((i, index) => (
                                        <Select.Option disabled={listFrames.includes(i.label)} key={index} value={i.label}>{i.label}</Select.Option>
                                    ))}
                                </Select>
                        }
                    </td>
                    {
                        !isMultiFrames &&
                        <td className="Quantity">
                            <Input
                                className="QtyTo"
                                type="number"
                                min={0}
                                placeholder="Số lượng <="
                                value={max}
                                suffix={false}
                                onChange={e => onChangeRecord(activeKey, 'max', e.target.value, index)}
                                style={{ width: '150px' }}
                            />
                        </td>
                    }
                    <td className="Partner ">
                        <Select
                            className={`${(!!validate.partner && validate.partner.length > 0) ? 'Error' : ''}`}
                            name="partner"
                            placeholder="Chọn partner"
                            value={partner || []}
                            allowClear
                            onChange={value => onChangeRecord(activeKey, 'partner', value, index)}
                            style={{ width: '150px' }}
                        >
                            {!!partners.length && partners.map((i, index) => (
                                <Select.Option key={i._id} value={i._id}>{i.name}</Select.Option>
                            ))
                            }
                        </Select>
                    </td>
                    {
                        !isMultiFrames &&
                        <td className="MinQuantity">
                            <Input
                                type="number"
                                min={1}
                                style={{ width: '150px' }}
                                value={min_per_batch}
                                onChange={e => onChangeRecord(activeKey, 'min_per_batch', e.target.value, index)}
                            />
                        </td>
                    }

                    <td className="MaxQuantity">
                        <Input
                            type="number"
                            min={1}
                            style={{ width: '150px' }}
                            value={max_per_batch}
                            disabled={isMultiFrames}
                            onChange={e => onChangeRecord(activeKey, 'max_per_batch', e.target.value, index)}
                        />
                    </td>
                    <td>
                        <Input
                            min={1}
                            style={{ width: '150px' }}
                            value={user_prefix}
                            onChange={e => onChangeRecord(activeKey, 'user_prefix', e.target.value, index)}
                        />
                    </td>
                    <td className="Status">
                        <div className="d-flex align-items-center">
                            <Input
                                type="checkbox"
                                className='custom-enable mr-2'
                                checked={is_enable}
                                onChange={() => onChangeRecord(activeKey, 'is_enable', !is_enable, index)}
                            />
                            {
                                conditions.length > 1 ?
                                    <Popconfirm placement='topRight' title={`Xóa thông tin tạo lô cho đối tác này?`} onConfirm={() => removeRecord(activeKey, index)}>
                                        <DeleteOutlined
                                            style={{
                                                pointerEvents: conditions.length <= 1 ? 'none' : 'unset',
                                                fontSize: '20px',
                                                cursor: 'pointer'
                                            }}
                                        />
                                    </Popconfirm> :
                                    <Tooltip title='Cần tối thiểu 1 điều kiện'>
                                        <DeleteOutlined
                                            style={{
                                                fontSize: '20px',
                                            }}
                                        />
                                    </Tooltip>
                            }
                        </div>
                    </td>
                </tr>
            )}
        </Draggable>
    )
}